import { useStack } from 'containers/StackProvider';
import { useId } from 'utilsTS/hooks';

export function useClickOutsideStack(defaultId: string | undefined, active: boolean): boolean {
    const id = useId('click-outside', defaultId);
    const stack = useStack('click-outside', id, active);
    const [activeId] = stack.slice(-1);

    if (activeId === undefined) return active;
    return id === activeId;
}
